export const BUILDER_EDITOR_LOGIN_BAR_COMPONENT_REF_V1 = 'wixMembersArea.LoginSocialBar';

export const BUILDER_EDITOR_LOGIN_BAR_COMPONENT_REF_V2 = 'wixMembersArea.LoginSocialBarV2';

export const resolveBuilderLoginBarComponentRef = (useLoginSocialBarV2: boolean): string =>
  useLoginSocialBarV2 ? BUILDER_EDITOR_LOGIN_BAR_COMPONENT_REF_V2 : BUILDER_EDITOR_LOGIN_BAR_COMPONENT_REF_V1;

// v1 is intentionally first: on mixed sites, lookups prefer the legacy instance.
export const getAllBuilderLoginBarComponentRefs = (): readonly [string, string] => [
  BUILDER_EDITOR_LOGIN_BAR_COMPONENT_REF_V1,
  BUILDER_EDITOR_LOGIN_BAR_COMPONENT_REF_V2,
];
